$(document).ready(function() {
	var wrapperHeight = $(".Product__Wrapper .flickity-viewport").height();
	console.log("Højde: " + wrapperHeight);
	$(".Product__SlideshowNav--thumbnails").css("height", wrapperHeight);

	// Cart agreement checkbox validation
	$(document).on('click', '#cart-checkout-link', function(e) {
		var checkbox = $('#cart-agreement-checkbox');
		
		// Check if checkbox exists and is not checked
		if (checkbox.length && !checkbox.is(':checked')) {
			e.preventDefault(); // Prevent navigation
			
			// Add visual feedback - highlight the checkbox area
			$('.Cart__Agreement').css({
				'border': '2px solid #ff0000',
				'border-radius': '4px',
				'padding': '10px',
				'background-color': '#ffe6e6'
			});
			
			// Show alert message
			alert('Du skal acceptere handelsbetingelser før du kan fortsætte til checkout.');
			
			// Remove visual feedback after 3 seconds
			setTimeout(function() {
				$('.Cart__Agreement').css({
					'border': 'none',
					'padding': '0',
					'background-color': 'transparent'
				});
			}, 3000);
			
			return false;
		}
	});
	
	// Remove visual feedback when checkbox is checked
	$(document).on('change', '#cart-agreement-checkbox', function() {
		if ($(this).is(':checked')) {
			$('.Cart__Agreement').css({
				'border': 'none',
				'padding': '0',
				'background-color': 'transparent'
			});
		}
	});
});
